import { render } from "./zhannaxinxi.vue?vue&type=template&id=9f04add0"
import script from "./zhannaxinxi.vue?vue&type=script&lang=js"
export * from "./zhannaxinxi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__